import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
    selector: 'ngx-detail-dialog',
    templateUrl: 'detail-dialog.component.html',
    styleUrls: ['detail-dialog.component.scss'],
})

export class DetailDialogComponent {
    @Input() title: string;
    @Input() dataSource: { columns: { titulo: string, valor: any }[] }[];
    @Input() button: string = "Cerrar";
    @Input() dataEvento: any;
    @Input() claves: any;
    @Input() cambioRecurso: any;


    constructor(protected ref: NbDialogRef<DetailDialogComponent>) {
    }


    dismiss() {
        this.ref.close();
    }
}